import $ from 'jquery';

const daysToStore = 183; //183 days(6 months) - round up to 183

// Viewership Source
$('select[name="additional[viewership_source]"]').val(null);
$('select').on('select2:open', function (e) { $('input.select2-search__field').attr("placeholder", "Type or select an option"); });
$('select[name="additional[viewership_source]"]').change(function (e) {
    var viewershipSource= e.target.value;
    localStorage.setItem('selectedViewershipSrc', viewershipSource);
    switch(viewershipSource) {
      case "national_tv_networks":
          $("#NetworkSourceTVNetwork").show();
          $("#NetworkSourceOnline").hide();
          $("#NetworkSourceStreaming").hide();
          break;

      case "online":
          $("#NetworkSourceOnline").show();
          $("#NetworkSourceStreaming").hide();
          $("#NetworkSourceTVNetwork").hide();
          break;

      case "streaming_apps":
          $("#NetworkSourceStreaming").show();
          $("#NetworkSourceTVNetwork").hide();
          $("#NetworkSourceOnline").hide();
          break;

      default:
          $("#NetworkSourceStreaming").hide();
          $("#NetworkSourceTVNetwork").hide();
          $("#NetworkSourceOnline").hide();
          break;
    }

    // Clear Viewership detail if Source has changed
    if(localStorage.selectedViewershipSrcDetail){
      $('select[name="additional[viewership_source_detail]"]').val(null);
      $('select[name="additional[viewership_source_detail]"]').select2().trigger('change');
      $('select[name="additional[viewership_source_detail]"]').select2({width: '100%', placeholder: "Select an option"});
    }
});

// Viewership Source Detail
$('select[name="additional[viewership_source_detail]"]').val(null);
$('select').on('select2:open', function (e) { $('input.select2-search__field').attr("placeholder", "Type or select an option"); });
$('select[name="additional[viewership_source_detail]"]').change(function (e) {
    $("#viewership-button").prop('disabled', false);
    localStorage.setItem('selectedViewershipSrcDetail',  e.target.value);
    $('select[name="additional[viewership_source_detail]"]').val(localStorage.selectedViewershipSrcDetail);
});

// Submit user_metadata_fields
$('#viewership-form').on('submit', function(e) {
    e.preventDefault();
    var viewership_source = localStorage.selectedViewershipSrc;
    var viewership_source_detail = localStorage.selectedViewershipSrcDetail;

    var requestData = {
        "_token" : $( 'input[name="_token"]' ).val(),
        "viewership_source" : viewership_source,
        "viewership_source_detail" : viewership_source_detail
    }

    $('#response-message-container').html('');

    $.ajax({
        type: "POST",
        url: "/api/viewership",
        data: requestData,
        dataType: "JSON",
        success: function (response){
            localStorage.clear(); // clear selectedViewershipSrc & selectedViewershipSrcDetail
            localStorage.setItem('userSubmittedViewershipSuccessfully', true);
            $('#response-message-container').html(buildMessage(response.status));
        }, error: function (response){
            localStorage.setItem('encounteredError', true);
            $('#response-message-container').html(buildMessage(response.status));
        }
    });
});

// Success/Error Message
function buildMessage(status, errorMsg){
    if(status=='success') {
        return '<div class="alert alert-success">' + "Thank you." + '</div>';
    }
    return '<div class="alert alert-warning"> An unexpected error occurred. </div>';
}

// add event listener on modal close
$('#viewership-source-modal').on('hidden.bs.modal', function () {
    if(!localStorage.userSubmittedViewershipSuccessfully && !localStorage.encounteredError)
    {
        localStorage.setItem('userDidNotSubmitViewershipDetails', true);
    }
})

// reset local storage - show popup again after 183 days(6 months) *round up to 183
window.onload = (event) => {
    var previousDate = new Date();
    var daysSinceLastClosed = calculateDateDifference('d', Date.parse(localStorage.getItem('previousDate')), new Date().getTime());

    if(!localStorage.previousDate)
    {
        localStorage.setItem('previousDate', previousDate);
    }

    if(daysSinceLastClosed > daysToStore)
    {
        localStorage.removeItem('userDidNotSubmitViewershipDetails');
        localStorage.removeItem('previousDate');
    }
};

// calculate date difference
function calculateDateDifference(datepart, fromdate, todate) {
    datepart = datepart.toLowerCase();
    var diff = todate - fromdate;
    var divideBy = { w:604800000,
                    d:86400000,
                    h:3600000,
                    n:60000,
                    s:1000 };

    return Math.ceil(diff/divideBy[datepart]);
}
